const subjectShortNames = {
  mathematics: "Maths",
  math: "Maths",
  biology: "Bio",
  chemistry: "Chem",
  physics: "Phy",
  english: "Eng",
  hindi: "Hin",
  sanskrit: "San",
  history: "Hist",
  geography: "Geo",
  civics: "Civ",
  "social studies": "SST",
  sst: "SST",
  science: "Sci",
};

export function xAxisLabelFormatter(rawLabel) {
  if (!rawLabel || typeof rawLabel !== "string") return rawLabel;

  const parts = rawLabel.trim().split(/\s+/); // Split by space(s)

  let classSection = "";
  let subjectParts = [];

  // Detect class-section pattern like VI-A, I-A etc.
  if (/^[IVXLC]+-[A-Z]$/i.test(parts[0])) {
    classSection = parts[0].toUpperCase();
    subjectParts = parts.slice(1);
  } else {
    subjectParts = parts; // No class-section found
  }

  const fullSubject = subjectParts.join(" ").toLowerCase();
  const shortSubject = subjectShortNames[fullSubject] || subjectParts.map(word => capitalize(word)).join(" ");

  return classSection ? `${classSection} ${shortSubject}` : shortSubject;
}

function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
